<template>
	<main>
		<div class="kv"></div>
		<div class="main">
			<div class="img">
				<img :src="require('@/assets/edm/pc/info.png')" alt="">
				<div class="btn" @click="util.toLink('/invitation')"></div>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'info',
	data() {
		return {

		}
	},
	components:{},
	computed:{

	},
	methods: {

	},
	mounted() {

	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.kv{height:624px;background: url("~@/assets/edm/pc/kv.png") no-repeat center center;background-size: cover;}
.main{text-align: center;background: url("~@/assets/edm/pc/bj.png") no-repeat top center;background-size: cover;
	.img{position: relative;
		.btn{position: absolute;bottom:180px;left:50%;transform: translateX(-50%); width: 234px;height:50px;background: url("~@/assets/edm/pc/info_btn.png") no-repeat center center;background-size: contain;cursor: pointer;}
	}
}
</style>

